import {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getDoc, doc, setDoc, getDocs, collection} from "firebase/firestore";
import {db} from "../firebase";
import like from "../img/like.svg";
export default function ProductInfo({user}) {

    const {first, second} = useParams();
    const [info, setInfo] = useState();
    const [amount, setAmount] = useState(1);
    const [newId, setNewId] = useState();

    useEffect(() => {
      getDoc(doc(db, "products", second)).then((item) => {
        setInfo(item.data());
      })
      
    }, [])
    
    
    async function handleCart(){
      let count = [];
      getDocs(collection(db, `users/${user.uid}/cart`)).then((snap) => {
        snap.forEach((item) => {
          count.push(item.data())
        })
        setDoc(doc(db, `users/${user.uid}/cart`, String(second + new Date().getTime())), {
          itemName: info.name,
          itemPrice: info.price,
          itemImg: info.img,
          itemAmount: Number(amount),
          id: count.length + 1,
          totalAmount: Number(Number(info.price) * Number(amount))
        }).then(() => {
          alert("Product Successfully Added To Cart 💖")
        })
      })
    }

    function handleLike(){
      setDoc(doc(db, `users/${user.uid}/wishlist`, info.docName), {
        docName: info.docName,
        itemImg: info.img,
        itemName: info.name,
        itemPrice: info.price,
        category: info.category
      }).then(() => {
        alert("Product Added To Wishlist 💕")
      })
    }

    
  return (
    <>
        {info && <div className='product-info'>
          <div className='info-left'><img src= {info.img}/></div>
          <div className='info-right'>
            <h2>{info.name}</h2>
            <p className='info-price'>₦ {info.price}</p>
            <button onClick={handleLike} className = "item-like-btn"><img src = {like}/></button>
            <label><b>Amount</b>:</label><input type= "number" value={amount} min = "1" onChange = {e => setAmount(e.target.value)} placeholder = "Enter Amount"/>
            <button className='info-btn' onClick={handleCart}>Add to cart</button>
            <div className='product-description'>
              <b>Description</b>
              {info.description.split(";").map((item) => {
                return <p>{item}</p>
              })}
          </div>
          </div>
          
          
        </div>}
    </>
  )
}

